<template>
  <div>
    <div v-cloak v-if="!ssoCodePosted" class="home">
      <p class="home--text">Unable to retrieve SSO token. Please check your configuration and try again.</p>
    </div>
    <div v-else class="home">
      <input style="height: 1px !important" ref="hiddenCodeInput" value="" type="hidden" v-model="cognitoResponse"/>
      <p class="home--text">You have been granted access. Click below to validate the authorization codes.</p>

      <div class="ssoCode">{{ssoCode}}</div>
      <div class="copyBtn" v-clipboard:copy="ssoCode" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy</div>
      <!-- <div class="copyBtn" @click="validateCode">Validate Code</div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: "SsoAccess",
  props: {
    msg: String
  },
  data: function() {
    return {
      ssoCode: undefined,
      ssoCodePosted: false,
      cognitoResponse: ''
    };
  },
  methods: {
    onCopy: function() {
      this.$toasted.success('Copied!')
      // this.$toasted.success('Access has been verified')
      // this.$toasted.show('You can now Authorize your account in StoryLink')
    },
    onError: function() {
      this.$toasted.error('Not able to copy to clipboard')
      // this.$toasted.error('The access codes are not valid')
    },
    validateCode: function(){
      /* --- NOT NEEDED
      const windowUrl = new URL(window.location);
      const queryParams = new URLSearchParams(windowUrl.search);
      const code = queryParams.get("code");

      const states = atob(queryParams.get("state")).split('+');
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      var urlencoded = new URLSearchParams();
      urlencoded.append("grant_type", "authorization_code");
      urlencoded.append("client_id", states[0]);
      urlencoded.append("redirect_uri", 'https://extensions.tenovos.io/storylink/index.html');
      urlencoded.append("code", code);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded
      };
      const url = `${states[1]}/oauth2/token`;
      fetch(url, requestOptions)
      .then(async response => {
        this.cognitoResponse = await response.json();
        this.cognitoResponse.key = "DAM-CONNECT-SSO-KEY";
        this.cognitoResponse = JSON.stringify(this.cognitoResponse);
        const el = this.$refs.hiddenCodeInput;
        if (!el) return
        try {
            el.select()
            document.execCommand("copy")
          }  catch (err) { console.log('Can\'t extract SSO Code') }
          el.value = ''
      })
      .catch(() =>{
        this.$toasted.error('Can\'t connect to the SSO provider')
        this.ssoCodePosted = false
      })
      */     
    }

  },
  mounted() {
    const windowUrl = new URL(window.location);
    const queryParams = new URLSearchParams(windowUrl.search);
    this.ssoCode = queryParams.get("code");
    
    if (!this.ssoCode) return this.$toasted.error('SSO Code is not available')
    else this.ssoCodePosted = true
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  padding: 0;
  list-style-type: none;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  text-align: center;
}
.home--textarea {
  width: 100%;
}
.copyBtn {
  width: 8rem;
  height: auto;
  padding: .25rem;
  font-size: .875rem;
  font-weight: 600;
  color: #ffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #0099da;
}

.ssoCode {
  padding: .5rem;
  margin: .25rem;
  font-size: .675rem;
  font-weight: 200;
  background-color: #e4e4e4;
}

.home--text {
  font-size: 1rem;
}

</style>
